<div class="container transition" [ngClass]="{'text-ltr':!languagesService.isRightToLeft,'text-rtl':languagesService.isRightToLeft}">
    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="form form-register" novalidate *ngIf="!error">

        <div class="row">
            <div class="col-md-1 col-lg-1 col-xs-0">
            </div>
            <div class="col-md-10 col-lg-10 col-xs-12">
                <div class="row">
                    <div class="col-md-12 col-xs-12 page-title" >
                        <div class="title" style="padding-left:0"><h2>{{'assistance-form.title'| translate}}</h2></div>
                        <hr>
                    </div>
                </div>
                <div class="row groups" id="tabHeadData">
                    <div class="col-md-12 col-xs-12 group">
                        <div class="col-md-0 col-xs-1"></div>
                        <div class="row">
                            <div class="col-md-12 col-xs-12 group-title">
                                <h5>{{'assistance-form.by-category'| translate}}</h5>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12 col-xs-12">
                                <div class="controls-group">
                                    <label>{{shem}}</label>
                                    <br/>
                                    <label>
                                        <span>{{'assistance-form.description1'| translate}}</span>
                                        <span style="font-weight: bold">{{'assistance-form.description2'| translate}}</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="row" class="col-md-12 col-xs-12">
                            <control-messages [control]="f.domain"></control-messages>
                        </div>
                        <div class="row">
                            <div class="col-md-12 col-xs-12">
                                <div class="controls-group">
                                    <div class="input-group">

                                        <label class="form-radio-label" *ngFor="let data of radioBtns">
                                            <input type="radio" formControlName="domain" [value]="data.value" (change)="checkDomain()">
                                            <span class="checkmark"></span> {{data.label}}
                                        </label>
            
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row" *ngIf="f.domain && ('1' == f.domain.value) ">
                            <div class="col-md-12 col-xs-12">
                                <div class="controls-group">
                                    <div class="input-group">
                                        <textarea type="text" class="form-control txt" maxlength="60" formControlName="content" placeholder="{{'assistance-form.content'| translate}}">
                                                </textarea>
                                    </div>
                                    <control-messages [control]="f.content"></control-messages>
                                </div>
                            </div>


                        </div>
                        <div *ngIf="f.domain && (('2' == f.domain.value) || ('3' == f.domain.value)) ">
                            <div class="row">
                                <div class="col-md-12 col-xs-12">
                                    <app-educition [form]="f.form_Educition"></app-educition>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12 col-xs-12">
                                    <app-profession [form]="f.form_Profession"></app-profession>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12 col-xs-12">
                                    <app-experience [form]="f.form_Experience"></app-experience>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-12 col-xs-12">
                                    <hr>
                                    <div class="controls-group">
                                        <div class="input-group">
                                            <textarea type="text" class="form-control txt" formControlName="Remarks" maxlength="64" placeholder="{{'assistance-form.Remarks'| translate}}">
                                        </textarea>
                                            <control-messages [control]="f.Remarks"></control-messages>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12 col-xs-12">
                                <div class="controls-group-h">
                                    <label class="form-check-label">
                                        <input type="checkbox" formControlName="agree">
                                        <span class="checkmark"></span> {{'assistance-form.agreement'| translate}}
                                        <a [routerLink]="" queryParamsHandling="preserve" (click)="openTermUsePopup()">{{'assistance-form.Terms-Use'| translate}}</a>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12 col-xs-12">
                                <div class="input-group text-ltr">
                                    <button [disabled]="f.agree && !f.agree.valid || dataSending" class="btn btn-material raised btn big">{{'assistance-form.send'| translate}}</button>
                                    <div class="col-md-1.5 col-xs-1.5"></div>
                                    <div class="row-big" *ngIf="!skipCaptcha">
                                        <div class="col-md-12 col-xs-12 ">
                                            <moia-captcha [isSubmitted]="isSubmitted" isFormValidation="true"></moia-captcha>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>            
        </div>   
        <app-popup-box [message]="message" [title]="msgBoxTitle" (closed)="message=''"></app-popup-box>    
    </form>
    <div *ngIf="error">
        <div class="row">
            <div class="col-md-12 col-xs-12">
                <div class="input-group text-ltr">
                    <label [innerHTML]="error" class="errorMessage"></label>
                </div>
            </div>
        </div>
    </div>
</div>